export const patientTagData = {
    "formType": 'patientTagData',
    "title": 'Реєстрація',
    "dataType": 'patientTagData',
    "fields": [
        {
            "id": 1,
            "type": 'text',
            "name": 'lastName',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": "Прізвище",
                    "type": 'text',
                    "placeholder": 'Прізвище'
                }
            ]
        }, {
            "id": 2,
            "type": 'text',
            "name": 'name',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": "Ім'я",
                    "type": 'text',
                    "placeholder": 'Ім\'я'
                }
            ]
        },{
            "id": 3,
            "type": 'text',
            "name": 'middleName',
            "required": false,
            "options": false,
            "props": [
                {
                    "label": "По батькові",
                    "type": 'text',
                    "placeholder": 'По батькові'
                }
            ]
        },
        {
            "id": 4,
            "type": 'select',
            "name": 'gender',
            "required": true,
            "options": true,
            "label": 'Стать',
            "props": [
                {
                    "name": 'Чоловік',
                    "value": 'male',
                    "type": 'option',
                    "id": 1
                }, {
                    "name": 'Жінка',
                    "value": 'female',
                    "type": 'option',
                    "id": 2
                }
            ]
        },
       {
            "id": 6,
            "type": 'text',
            "name": 'cardNumber',
            "required": false,
            "options": false,
            "props": [
                {
                    "label": "Номер картки",
                    "type": 'text',
                    "placeholder": 'Номер картки'
                }
            ]
        },{
            "id": 7,
            "type": 'text',
            "name": 'patientNumber',
            "required": false,
            "options": false,
            "props": [
                {
                    "label": "Номер пацієнта",
                    "type": 'text',
                    "placeholder": 'Номер пацієнта'
                }
            ]
        },{
            "id": 8,
            "type": 'tel',
            "required": false,
            "name": 'phoneNumber',
            "max": 13,
            "options": false,
            "props": [
                {
                    "label": "Моб. Телефон Пацієнта",
                    "type": 'tel',
                    "patter": '[0-9]*',
                    "placeholder": '+380967778899',
                    "inputProps": {
                        "onKeyPress": (e) => {
                            if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                            }
                        }
                    }
                },
            ]
        }
    ],
    "button": 'Зареєструвати',
    "class": 'form__box__login'
}